import React from 'react';
import { Text } from '@radix-ui/themes';
import roleplayIcon from '../../../../assets/images/roleplay.png';

const RpCommence = () => {
  return (
    <div className="flex flex-1 justify-center items-center">
      <img
        src={roleplayIcon}
        alt="Roleplay"
        className="h-[15vh] w-[25vw] max-h-[120px] max-w-[150px] object-contain"
      />
      <Text
        as="span"
        size="4"
        className="text-white py-[1.5vh] font-[Lato-Regular] text-center w-[60vw] mb-[1vh]"
      >
        Standby ... you will shortly commence the Case Study & Analysis
      </Text>
    </div>
  );
};

export default RpCommence;